import { enUSStr, zhCNStr } from '@/constants';
import enUS from './en-US';
import zhCN from './zh-CN';

const locales = {
    [enUSStr]: enUS,
    [zhCNStr]: zhCN,
};

export default locales;
